import { Component, Input } from '@angular/core';
import { remove } from 'lodash';
import { IListViewData } from '../../../../shared/typings/interfaces/list-view.interface';
import { ListDisplay } from '../list-display.component';

@Component({
  selector: 'list-display-graph',
  template: require('./list-display-graph.component.html'),
})
export class ListDisplayGraph extends ListDisplay {
  @Input() graphName: string;

  rowClick(dataRow) {
    const navDataType = this.parsedData.navDataType;
    const navData = dataRow[this.navDataIndex][this.parsedData.navData.key].filterValue;
    const studentIds = dataRow[this.navDataIndex][this.parsedData.navData.key].studentIds;
    const subject = dataRow[this.navDataIndex][this.parsedData.navData.key].subject;
    const cachedStudentIds = this.objectCache.cacheObject({ studentIds });

    this.$state.go(
      this.parsedData.navRoute,
      { graphName: this.graphName, navDataType, navData, studentIds: cachedStudentIds, subject },
      { location: 'replace' },
    );
  }

  // override #formatData to not filter out empty sections when list type is postsec
  formatData(parsedData: IListViewData): void {
    this.colHeaders = this.getColumnHeaders(parsedData);
    this.formattedList = this.formatList(parsedData);
    this.setListLevelStyle(this.parsedData);
  }

  // override #formatLIst to not filter out empty sections when list type is postsec
  formatList(listData: IListViewData): IListViewData {
    this.dataFormatted = false;
    listData.sections.forEach(section => {
      // check if default number of rows to display is larger than available data rows
      let rowsToDisplay = section.defaultDisplayCount;
      const availableRows = section.data.length;
      if (rowsToDisplay > availableRows) rowsToDisplay = availableRows;
      this.formatSection(section, rowsToDisplay);
    });

    this.dataFormatted = true;
    return listData;
  }
}
